import { NgModule } from '@angular/core';
import { CommonModule,  } from '@angular/common';
import { FileListComponent } from './file-list/file-list.component';
import { FileListRoutingModule } from './file-list-routing.module';
import { ComponentsModule } from '@material-library';
import { SharedModule } from '../shared/shared.module';
import { FileInfoComponent } from './file-info/file-info.component';
import { DialogCreateBlankDocumentComponent } from './dialog-create-blank-document/dialog-create-blank-document.component';
import { DialogUploadComponent } from './dialog-upload/dialog-upload.component';
import { DialogPurgeComponent } from './dialog-purge/dialog-purge.component';
import { DialogRestoreComponent } from './dialog-restore/dialog-restore.component';
import { DialogUpgradeComponent } from './dialog-upgrade/dialog-upgrade.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileInfoDialogComponent } from './dialog-file-info/dialog-file-info.component';
@NgModule({
  declarations: [
    FileInfoComponent,
    DialogCreateBlankDocumentComponent,
    DialogUploadComponent,
    DialogUploadComponent,
    DialogPurgeComponent,
    DialogRestoreComponent,
    FileListComponent,
    DialogUpgradeComponent,
    FileInfoDialogComponent,
  ],
  imports: [
    CommonModule,
    FileListRoutingModule,
    ComponentsModule,
    SharedModule,
    MatTooltipModule
  ],
  exports: [
    FileInfoComponent,
    DialogCreateBlankDocumentComponent,
    DialogPurgeComponent,
    DialogRestoreComponent,
    DialogUploadComponent,
  ],
})
export class FileListModule { }
